import React from "react";
import axiosInstance from "../../utils/axiosInstance";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../css/errors.css";

const ChangePassword = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmPassword: ""
    },
    validationSchema: Yup.object({
      currentPassword: Yup.string().required("L'ancien mot de passe est requis"),
      newPassword: Yup.string()
        .min(6, "Le mot de passe doit contenir au moins 6 caractères")
        .required("Le nouveau mot de passe est requis"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Les mots de passe ne correspondent pas")
        .required("La confirmation est requise")
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        console.log(values)
        await axiosInstance.post(`${baseUrl}/api/auth/ChangePassword`, values);

        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Mot de passe modifié avec succès !",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true
        });

        resetForm();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text:
            error.response?.data?.message ||
            "Échec du changement de mot de passe. Vérifiez vos informations."
        });
      }
    }
  });

  return (
    <div className="container mt-4">
      <h4 className="mb-3">Changer le mot de passe</h4>
      <hr />

      <form onSubmit={formik.handleSubmit} className="col-md-6 mx-auto">
        {/* Ancien mot de passe */}
        <div className="form-group mb-3">
          <label>Ancien mot de passe</label>
          <input
            type="password"
            name="currentPassword"
            className={`form-control ${
              formik.errors.currentPassword && formik.touched.currentPassword ? "is-invalid" : ""
            }`}
            value={formik.values.currentPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.currentPassword && formik.errors.currentPassword && (
            <div className="invalid-feedback custom-error">
              {formik.errors.currentPassword}
            </div>
          )}
        </div>

        {/* Nouveau mot de passe */}
        <div className="form-group mb-3">
          <label>Nouveau mot de passe</label>
          <input
            type="password"
            name="newPassword"
            className={`form-control ${
              formik.errors.newPassword && formik.touched.newPassword ? "is-invalid" : ""
            }`}
            value={formik.values.newPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.newPassword && formik.errors.newPassword && (
            <div className="invalid-feedback custom-error">
              {formik.errors.newPassword}
            </div>
          )}
        </div>

        {/* Confirmation */}
        <div className="form-group mb-3">
          <label>Confirmer le mot de passe</label>
          <input
            type="password"
            name="confirmPassword"
            className={`form-control ${
              formik.errors.confirmPassword && formik.touched.confirmPassword
                ? "is-invalid"
                : ""
            }`}
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.confirmPassword && formik.errors.confirmPassword && (
            <div className="invalid-feedback custom-error">
              {formik.errors.confirmPassword}
            </div>
          )}
        </div>

        {/* Boutons */}
        <div className="d-flex justify-content-end gap-2">
          <button
            type="button"
            className="btn btn-annuler"
            onClick={() => formik.resetForm()}
          >
            Annuler
          </button>
          <button type="submit" className="btn btn-enregistrer ml-2">
            Enregistrer
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;